/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobArchiveUpdateCto } from '../../models/job-archive-update-cto';
import { PositionCto } from '../../models/position-cto';

export interface UpdateJobArchiveStatusAsync$Json$Params {
  positionGuid: string;
      body?: JobArchiveUpdateCto
}

export function updateJobArchiveStatusAsync$Json(http: HttpClient, rootUrl: string, params: UpdateJobArchiveStatusAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
  const rb = new RequestBuilder(rootUrl, updateJobArchiveStatusAsync$Json.PATH, 'patch');
  if (params) {
    rb.path('positionGuid', params.positionGuid, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PositionCto>;
    })
  );
}

updateJobArchiveStatusAsync$Json.PATH = '/job/{positionGuid}/archive';
